import { useForm } from "react-hook-form";
import { useRouter } from "expo-router";
import { useLoginMutation } from "app/services/api/authorisationApi";
import { LoginRequest } from "app/services/api/types/authorisation/requests/LoginRequest";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { HomePath } from "app/constants/routePaths";

export const useLogin = () => {
  const [triggerLogin, { isLoading }] = useLoginMutation();
  const { showErrorToast } = useDisplayToast();
  const router = useRouter();

  const { control, handleSubmit } = useForm<LoginRequest>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const submitForm = handleSubmit(async (data: LoginRequest) => {
    try {
      const authUser = await triggerLogin(data).unwrap();

      if (authUser?.token_data.token) {
        router.push(HomePath);
      }
    } catch (e) {
      showErrorToast(e, {
        title:
          e?.status === 401 ? "Invalid Credentials" : "Something went wrong",
        statusOverride: {
          401: "These login credentials are invalid. Please try again.",
        },
      });
    }
  });

  return { control, submitForm, isLoading };
};
